import { render, staticRenderFns } from "./kswbookactive.vue?vue&type=template&id=1d691ef9&scoped=true"
import script from "./kswbookactive.vue?vue&type=script&lang=js"
export * from "./kswbookactive.vue?vue&type=script&lang=js"
import style0 from "./kswbookactive.vue?vue&type=style&index=0&id=1d691ef9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d691ef9",
  null
  
)

export default component.exports